<template>
  <div v-if="!loading">
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        searchnew: this.search,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:delete="isConfirm = !isConfirm"
      v-on:new="createHandler"
      v-on:error="isErr = $event.isErr; errMsg = $event.errMsg"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
    <div v-if="isConfirm">
      <app-confirm
        v-bind:parentObject="{
          pageTitleValue: this.pageTitleValue,
          isConfirm: this.isConfirm,
        }"
        v-on:confirm="deleteHandler($event)"
        v-on:cancelConfirm="isConfirm = !isConfirm"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";

import AppForm from "../../../components/payroll/mmmonthlyssbsubmissionrec/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": AppForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('mmmonthlyssb.editssbsubmissionrec'),
      pageTitleValue: "",
      formData: [],
      headLoading: true,
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
      dataItems: [],
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    //load statutory report by id
    loadStatutoryReport() {
      const vm = this;

      this.$store.dispatch('get', {url: "/mmssbsubmissionrecord/" + this.id})
        .then((res) => {
          vm.formData = res.data.rec[0];

          vm.pageTitleValue = res.data.rec[0].ssbsubreccode;
          vm.formData.userid = this.$store.getters.userId;

          vm.loadSSBSubRecPayout();

          //vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    //load ssb sub rec payout
    loadSSBSubRecPayout() {
      const vm = this;

      this.$store.dispatch('get', {url: "/mmssbsubmissionrecordpy/" + this.id})
        .then((res) => {
          vm.formData.ssbSelectedPayouts = res.data.rec;

          for (let i = 0; i < vm.formData.ssbSelectedPayouts.length; i++) {
            Object.assign(vm.formData.ssbSelectedPayouts[i], { action: 2 });
          }

          vm.loadSSBSubRecRef();

          //vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    //load ssb sub rec ref
    loadSSBSubRecRef() {
      const vm = this;

      this.$store.dispatch('get', {url: "/mmssbsubmissionrecordref/" + this.id})
        .then((res) => {
          vm.formData.ssbSubDetail = res.data.rec;

          for (let i = 0; i < vm.formData.ssbSubDetail.length; i++) {
            if (vm.formData.ssbSubDetail[i].rcpdate) {
              vm.formData.ssbSubDetail[i].rcpdate = moment(
                vm.formData.ssbSubDetail[i].rcpdate
              ).format("YYYY-MM-DD");
            }

            vm.formData.ssbSubDetail[i].no = i + 1;
          }

          for (let i = 0; i < vm.formData.ssbSubDetail.length; i++) {
            Object.assign(vm.formData.ssbSubDetail[i], { action: 2 });
             Object.assign(vm.formData.ssbSubDetail[i], { no: i + 1 });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      //update record
      this.$store.dispatch('put', {url: "/mmssbsubmissionrecord/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "mmmonthlyssbsubmissionrecordlist", params: { search: this.search} });
          }
        })
        .catch((err) => {
          //emit error --> req failure
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/mmssbsubmissionrecord/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "mmmonthlyssbsubmissionrecordlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "mmmonthlyssbsubmissionrecordlist" });
    },

    createHandler() {
      this.$router.push({ name: "mmmonthlyssbsubmissionrecordnew" });
    },
  },

  mounted() {
    this.loadStatutoryReport();
    // this.loadSSBSubRecPayout();
    // this.loadSSBSubRecRef();
  },
};
</script>